"use client";

import { useRouter } from "next/navigation";
import { env } from "@/lib/env";

export function scrollToTop() {
  if (typeof window !== "undefined") {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

export function getBaseUrl() {
  if (typeof window !== "undefined") return "";
  if (env.VERCEL_URL) return `https://${env.VERCEL_URL}`;
  return "http://localhost:3000";
}

export const routes = {
  home: "/",
  blog: "/resources",
  about: "/about",
  pricing: "/pricing",
  status: "/system-status",
  support: "/support",
  tools: "/tools",
  resources: "/resources",
  terms: "/terms",
  privacy: "/privacy",
  integrations: "/integrations",
  partners: "/partners",
  cases: "/cases",
  demo: "/demo",
  security: "/security",
  docs: "/resources",
  enterprise: "/enterprise",
  gov: "/gov",
} as const;

export const externalRoutes = {
  blog: "https://blog.sendbot.co/",
  docs: "https://docs.sendbot.co/",
} as const;

export type Routes = typeof routes;
export type RoutePath = Routes[keyof Routes];

export function useRouting() {
  const router = useRouter();

  const navigate = (path: RoutePath) => {
    scrollToTop();
    router.push(path);
  };

  return {
    navigate,
    routes,
    externalRoutes,
  };
}
